import Vue from 'vue'
import VueApollo from 'vue-apollo'
import { ApolloClient } from 'apollo-client'
import { HttpLink } from 'apollo-link-http'
import { setContext } from 'apollo-link-context'
import { InMemoryCache } from 'apollo-cache-inmemory'

import { split } from 'apollo-link'
import { WebSocketLink } from 'apollo-link-ws'
import { getMainDefinition } from 'apollo-utilities'
import config from '@/config'

const httpLink = new HttpLink({
  // You should use an absolute URL here
  uri: config.ENDPOINTS.CAT4MRO_HTTP
})

const authLink = setContext((_, { headers }) => {
  // create the web socket link
  return {
    headers: {
      ...headers,
      'x-hasura-admin-secret': config.ENDPOINTS.CAT4MRO_SECRET
    }
  }
})

// Create the subscription websocket link
const wsLink = new WebSocketLink({
  uri: config.ENDPOINTS.CAT4MRO_WS,
  options: {
    reconnect: true,
    connectionParams: () => {
      return { headers: { 'x-hasura-admin-secret': config.ENDPOINTS.CAT4MRO_SECRET } }
    }
  }
})

// using the ability to split links, you can send data to each link
// depending on what kind of operation is being sent
const link = split(
  // split based on operation type
  ({ query }) => {
    const definition = getMainDefinition(query)
    return definition.kind === 'OperationDefinition' &&
      definition.operation === 'subscription'
  },
  wsLink,
  authLink.concat(httpLink)
)

const cache = new InMemoryCache({
  dataIdFromObject: o => o.id
})

// Create the apollo client
export const apolloClient = new ApolloClient({
  link: link,
  cache,
  connectToDevTools: true
})

const apolloProvider = new VueApollo({
  defaultClient: apolloClient
})

// Install the vue plugin
Vue.use(VueApollo)

export default apolloProvider



// WEBPACK FOOTER //
// ./src/apollo.js